import { Component, OnInit } from '@angular/core';
import { ApiConnectionService } from '../services/api-connection.service'

@Component({
  selector: 'app-all-races',
  templateUrl: './all-races.component.html',
  styleUrls: ['./all-races.component.scss']
})
export class AllRacesComponent implements OnInit {

  allRaces: any = [];
  endedRacesList: any = [];
  initYear : any;
  initMonth : any;
  initDay : any;

  inactiveRaces: boolean = false;

  // Merchant config

  primaryColor: string;
  constructor(
    private apiService: ApiConnectionService
  ) { }

  ngOnInit() {
    let _ = this;
    _.configByMerchant();
  }

  ngAfterViewInit(){
    let _ = this;
    _.getRaces();
  }

  configByMerchant(){
    let _ = this;
    let conditions = {
     "conditions":{
        "merchant": _.getMerchant(),
      },
    }
    _.apiService.getMerchantDesign(conditions).subscribe(data => {
      console.log(data);
      _.primaryColor = data['results'][0].design.color;
    })
  }

  getMerchant(){
    let _ = this;
    let merchant: any = location.href.split('/');

    return merchant[3];
  }

  getRaces(){
    let _ = this;
    let conditions = {
     "conditions":{
        "active": true,                                     // Optional field
      },
      "merchant": _.getMerchant(),                                 // Mandatory field
    }
    _.apiService.getQuantities(conditions).subscribe(data => {
      let activeRacesResponse = data['results'];
      for(let i = 0; i < activeRacesResponse.length; i++){
        let currentDate = new Date();
        let endRaceDate = new Date(activeRacesResponse[i].end_date);
        if (currentDate < endRaceDate){
          _.allRaces.push(activeRacesResponse[i]);
        }else{
          _.endedRacesList.push(activeRacesResponse[i]);
        }
      }
    })
  }

  translateEndDate(date){
    let _ = this;
    let parseDay: any;
    let parseMonth: any;
    let parseYear: any;
    let parseDate: any = date.split('T');
    let monthList = [
      'enero',
      'febrero',
      'marzo',
      'abril',
      'mayo',
      'junio',
      'julio',
      'agosto',
      'septiembre',
      'octubre',
      'noviembre',
      'diciembre'
    ]
    parseDate = parseDate[0];
    parseMonth = parseDate.split('-');
    parseDay = parseMonth[2];
    parseYear = parseMonth[0];
    parseMonth = monthList[parseMonth[1] - 1];
    parseDate = parseDay + ' ' + parseMonth + ' ' + parseYear;

    return parseDate;
  }

  translateInitDate(date){
    let _ = this;
    let monthList = [
      'enero',
      'febrero',
      'marzo',
      'abril',
      'mayo',
      'junio',
      'julio',
      'agosto',
      'septiembre',
      'octubre',
      'noviembre',
      'diciembre'
    ]
    let parseDate = date.split('T');
    parseDate = parseDate[0];
    parseDate = parseDate.split('-');
    _.initMonth =  monthList[parseDate[1] - 1];
    _.initDay = parseDate[2];
  }

  percentageBar(goalAmount, currentAmount){
    let currentAmountOperation = parseInt(currentAmount.replace(/,/g, '')) * 100;
    let goalAmountOperation = parseInt(goalAmount.replace(/,/g, ''))

    return (currentAmountOperation / goalAmountOperation).toFixed(2);
  }

  openRace(raceUrl){
    let _ = this;
    let win = window.open("/" + _.getMerchant() + "/" + raceUrl, '_blank');
    win.focus();
  }
}
